import React, { useState } from "react";
import Collapsible from "react-collapsible";
import RichText from "components/rich-text";
import { ReactComponent as PlusIcon } from "assets/svgs/plusgrey.svg";
import { ReactComponent as MinusIcon } from "assets/svgs/minusgrey.svg";
import clsx from "clsx/lite";

const CollapsibleInfo = ({ title, subtitle = "", content, className, triggerClass = "" }) => {
	const [isOpen, setIsOpen] = useState(false);
	const triggerId = React.useId("trigger");
	if ((!title && !subtitle) || !content) return null;
	
	return (
		<div className={className}>
			<Collapsible
				className="bg-beige rounded-xl border-none" openedClassName="bg-beige rounded-xl border-none"
				onOpening={() => setIsOpen(true)}
				onClosing={() => setIsOpen(false)}
				trigger={[
					<div key={triggerId} className="flex justify-between items-center px-5 py-2 w-full">
						<div className="w-11/12">
							{title && <span className={clsx("font-boldParagraph", triggerClass)}>{title}</span>}
							{subtitle && <span className={clsx(triggerClass)}>{" "}{subtitle}</span>}
						</div>
						{isOpen ? <MinusIcon /> : <PlusIcon />}
					</div>]}
			>
				{content && <div className="px-8 text-base"><RichText value={content} /></div>}
			</Collapsible >
		</div>
	);
};

export default CollapsibleInfo;